/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ヒストリーtype
 * @export
 * @enum {string}
 */

export const HistoryType = {
    CallResult: 'call_result',
    DirectMail: 'direct_mail',
    BulkMail: 'bulk_mail',
    NextAction: 'next_action',
    Comment: 'comment',
    Opportunity: 'opportunity'
} as const;

export type HistoryType = typeof HistoryType[keyof typeof HistoryType];



